import * as DOMUtils from "history/DOMUtils";
import type { ToolsModalItemType } from "../../../../common-deprecated/features/new-cars/debug-modal/components/ToolsModal";
import {
    getRetailerDebugToggleLink,
    objectToQueryString,
    queryStringToObject,
} from "../../../../common-deprecated/utils";
import { useCarConfigSelector } from "../redux/store";
import {
    COMPONENT_BUILDANDBUY,
    COMPONENT_COMPARE_V2,
    COMPONENT_EQUIPMENT_OPTIONAL,
    COMPONENT_EQUIPMENT_STANDARD,
    COMPONENT_PDF,
    ENDPOINT_COMPONENT_MAP,
} from "../../../../shared-logic/server/components";

/**
 * Returns a set of apheleia car config specific debugging links for the tools modal
 */
const useAphTools = (): ToolsModalItemType[] => {
    const tyCode: string | undefined = useCarConfigSelector(
        (state) => state.save.data?.Personal?.Code || state.save.data?.ConfigurationCode,
    );

    const resourcePath = useCarConfigSelector((state) => state.commonSettings.resourcePath);
    const country = useCarConfigSelector((state) => state.commonSettings.country);
    const language = useCarConfigSelector((state) => state.commonSettings.language);
    const modelMap = useCarConfigSelector((state) => state.commonSettings.modelMap);

    const carData = useCarConfigSelector((state) => state.car);
    const colour = useCarConfigSelector((state) => state.basket?.colour);
    const modelId = carData.model.id;
    const carId = carData.id;

    const submodelId = carData?.submodel?.id || "";
    const gradeId = carData?.grade?.id || "";
    const bodyTypeId = carData?.body?.id || "";
    const engineId = carData?.motorization?.engine?.id || "";
    const wheeldriveId = carData?.wheel?.id || "";
    const transmissionId = carData?.motorization?.transmission?.id || "";
    const location = DOMUtils.canUseDOM ? window.location : { origin: "", pathname: "", search: "" };
    const currentPath = `${location.origin}${location.pathname}`;
    const parsedQuery = queryStringToObject(location.search);

    // modeltoken url
    let tokenUrl = "";
    const model = Object.values(modelMap).find((mapModel) => mapModel.id === modelId);
    if (model && model.token) {
        const tokenQuery = objectToQueryString({
            ...parsedQuery,
            modelToken: model.token,
        });
        tokenUrl = `${currentPath}?${tokenQuery}`;
    }

    const envEndpoint = `${resourcePath}/${country}/${language}`;
    const carDetailQuery = objectToQueryString({ modelId, carId });
    const standardEquipmentUrl = carId
        ? `${envEndpoint}/${ENDPOINT_COMPONENT_MAP[COMPONENT_EQUIPMENT_STANDARD]}?${carDetailQuery}&carColourId=${
              colour?.id || ""
          }`
        : "";
    const optionalEquipmentUrl = carId
        ? `${envEndpoint}/${ENDPOINT_COMPONENT_MAP[COMPONENT_EQUIPMENT_OPTIONAL]}?${carDetailQuery}&carColourId=${
              colour?.id || ""
          }`
        : "";
    const compareV2Url = gradeId
        ? `${envEndpoint}/${
              ENDPOINT_COMPONENT_MAP[COMPONENT_COMPARE_V2]
          }?compareData=${modelId}:${submodelId}:${gradeId}:${bodyTypeId}:${engineId}:${wheeldriveId}:${transmissionId}:${
              colour?.code || ""
          }`
        : "";
    const pdfUrl = tyCode ? `${envEndpoint}/${ENDPOINT_COMPONENT_MAP[COMPONENT_PDF]}?tyCode=${tyCode}` : "";
    const buildUrl = carId
        ? `${envEndpoint}/${ENDPOINT_COMPONENT_MAP[COMPONENT_BUILDANDBUY]}?${objectToQueryString({
              ...parsedQuery,
              path: `customize/${modelId}/${carId}`,
          })}`
        : "";

    return [
        { links: [{ title: "Model token URL", href: tokenUrl, redirect: true }] },
        { links: [{ title: "Set Tradein valuation", onClickLogic: "set-trade-in-valuation" }] },
        getRetailerDebugToggleLink(),
        {
            title: "Other components:",
            links: [
                standardEquipmentUrl ? { href: standardEquipmentUrl, title: "Standard Equipment" } : false,
                optionalEquipmentUrl ? { href: optionalEquipmentUrl, title: "Optional Equipment" } : false,
                compareV2Url ? { href: compareV2Url, title: "Compare V2" } : false,
                pdfUrl ? { href: pdfUrl, title: "Summary PDF" } : false,
                buildUrl ? { href: buildUrl, title: "Build" } : false,
            ],
        },
    ];
};

export default useAphTools;
